import {Component, Input} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-answers-assistances',
  standalone: true,
  imports: [
    NgForOf,
    NgIf
  ],
  templateUrl: './answers-assistances.component.html',
  styleUrl: './answers-assistances.component.scss'
})
export class AnswersAssistancesComponent {

  @Input() assistances?: Array<any>;

}
